import React from "react";

function RadioButton(props) {
    return (
        <div className={`u_radio-btn ${props.className}`}>
            <input type="radio" {...props}/>
            <label htmlFor={props.id}>{props.label}</label>
        </div>
    )
}

export default RadioButton;
